import { Component, Input, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ModalDirective, ModalModule } from 'ngx-bootstrap/modal';
import { ApiLanguagesService } from '../../../../../services/languages/api/api-languages.service';
import { AlertsService } from '../../../../../services/alerts.service';

@Component({
  selector: 'app-language-translation-edit-modal',
  templateUrl: './language-translation-edit-modal.component.html',
  standalone: true,
  imports: [ModalModule, CommonModule, FormsModule]
})
export class LanguageTranslationEditModalComponent {

  @Input() languageId: number = 0;

  @ViewChild('modal') modal!: ModalDirective;

  isLoading: boolean = false;
  translationId: number = 0;
  translationKey: string = '';
  translationValue: string = '';

  private callbackSaved?: () => void;

  constructor(private apiLanguagesService: ApiLanguagesService, private alertsService: AlertsService) {}

  show(translationId: number, translationKey: string, translationValue: string, callbackSaved?: () => void): void {
    this.callbackSaved = callbackSaved;
    this.translationId = translationId;
    this.translationKey = translationKey;
    this.translationValue = translationValue;
    this.isLoading = false;
    this.modal.show();
  }

  save(): void {
    this.isLoading = true;
    this.apiLanguagesService.editLanguageTranslation(this.languageId, this.translationId, this.translationKey, this.translationValue).then(
      () => {
        this.isLoading = false;
        this.modal.hide();
        this.alertsService.displayAlertSuccess('Translation updated !');
        if (this.callbackSaved) { this.callbackSaved(); }
      }, error => {
        this.isLoading = false;
        this.alertsService.displayAlertError('Error updating translation : ' + error);
      }
    );
  }
}
